import { render, staticRenderFns } from "./AddRulesPage.vue?vue&type=template&id=c54bc158&scoped=true"
import script from "./AddRulesPage.vue?vue&type=script&lang=ts"
export * from "./AddRulesPage.vue?vue&type=script&lang=ts"
import style0 from "./AddRulesPage.vue?vue&type=style&index=0&id=c54bc158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54bc158",
  null
  
)

export default component.exports